import { NewFrameDimension } from '@cutr/constants/windows/windows-presets.ts';

import { events } from './events';
import { useKonva } from './KonvaContext';
import { LineInput } from './primitives/LineInput';
import { Box } from './types';

type BaseLineProps = {
  min: number;
  max: number;
  box: Box;
};

type LineProps = BaseLineProps & {
  name: NewFrameDimension['name'];
};

type AreaLineProps = BaseLineProps & {
  index: number;
};

export const FrameWidthLineInput = ({ name, box, min, max }: LineProps) => {
  const { x, y, height } = box;
  const { stageRef } = useKonva();
  const lineBox = {
    ...box,
    x: x,
    y: y + height / 2,
  };

  const onSubmit = (value: number) => {
    stageRef.current?.fire(
      events.frameDimensionChange,
      {
        value,
        name,
      },
      true
    );
  };

  return (
    <LineInput
      value={box.width}
      min={min}
      max={max}
      direction="horizontal"
      box={lineBox}
      options={{
        altTriangle: true,
      }}
      onSubmit={onSubmit}
    />
  );
};

export const FrameHeightLineInput = ({ name, box, min, max }: LineProps) => {
  const { x, y, width } = box;
  const { stageRef } = useKonva();
  const lineBox = {
    ...box,
    x: x + width / 2,
    y: y,
  };

  const onSubmit = (value: number) => {
    stageRef.current?.fire(
      events.frameDimensionChange,
      {
        value,
        name,
      },
      true
    );
  };

  return (
    <LineInput
      value={box.height}
      min={min}
      max={max}
      direction="vertical"
      box={lineBox}
      options={{
        altTriangle: true,
      }}
      onSubmit={onSubmit}
    />
  );
};

export const AreaWidthLineInput = ({ index, box, min, max }: AreaLineProps) => {
  const { x, y, height } = box;
  const { stageRef } = useKonva();
  const lineBox = {
    ...box,
    x: x,
    y: y + height / 2,
  };

  const onSubmit = (value: number) => {
    stageRef.current?.fire(
      events.areaDimensionChange,
      {
        value,
        index,
        dimension: 'x',
      },
      false
    );
  };

  return (
    <LineInput
      value={box.width}
      min={min}
      max={max}
      direction="horizontal"
      box={lineBox}
      options={{
        altTriangle: true,
      }}
      onSubmit={onSubmit}
    />
  );
};

export const AreaHeightLineInput = ({
  index,
  box,
  min,
  max,
}: AreaLineProps) => {
  const { x, y, width } = box;
  const { stageRef } = useKonva();
  const lineBox = {
    ...box,
    x: x + width / 2,
    y: y,
  };

  const onSubmit = (value: number) => {
    stageRef.current?.fire(
      events.areaDimensionChange,
      {
        value,
        index,
        dimension: 'y',
      },
      true
    );
  };

  return (
    <LineInput
      value={box.height}
      min={min}
      max={max}
      direction="vertical"
      box={lineBox}
      options={{
        altTriangle: true,
      }}
      onSubmit={onSubmit}
    />
  );
};
